export const DATA_CY_COMMUNITY = 'community';
export const DATA_CY_JOIN_COMMUNITY = 'join-community';
